<template>
  <g clip-path="url(#clip0_8336_17695)">
    <path
      d="M6.66732 14.6667C4.15316 14.6667 2.89608 14.6667 2.11503 13.8856C1.33398 13.1046 1.33398 12.5142 1.33398 10"
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    <path
      d="M14.6673 10C14.6673 12.5142 14.6673 13.1046 13.8863 13.8856C13.1052 14.6667 11.8481 14.6667 9.33398 14.6667"
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    <path
      d="M9.33398 1.33301C11.8481 1.33301 13.1052 1.33301 13.8863 2.11406C14.6673 2.8951 14.6673 3.48552 14.6673 5.99967"
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    <path
      d="M6.66732 1.33301C4.15316 1.33301 2.89608 1.33301 2.11503 2.11406C1.33398 2.8951 1.33398 3.48552 1.33398 5.99967"
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    <path
      d="M3.92893 9.37352C3.5323 8.91344 3.33398 8.6834 3.33398 8.00033C3.33398 7.31725 3.5323 7.08721 3.92893 6.62713C4.7209 5.70847 6.0491 4.66699 8.00065 4.66699C9.9522 4.66699 11.2804 5.70847 12.0724 6.62713C12.469 7.08721 12.6673 7.31725 12.6673 8.00033C12.6673 8.6834 12.469 8.91344 12.0724 9.37352C11.2804 10.2922 9.9522 11.3337 8.00065 11.3337C6.0491 11.3337 4.7209 10.2922 3.92893 9.37352Z"
      stroke="currentColor" stroke-width="1.2" />
    <circle cx="7.99935" cy="8.00033" r="1.33333" stroke="currentColor" stroke-width="1.2" />
  </g>
  <defs>
    <clipPath id="clip0_8336_17695">
      <rect width="16" height="16" rx="5" fill="white" />
    </clipPath>
  </defs>
</template>
